<template>
  <v-row justify="center">
    <v-dialog
      v-model="enable"
      persistent
      max-width="300"
      @keydown.esc="cancel()"
    >
      <v-card>
        <v-card-title class="headline"> Growth subscribers only </v-card-title>
        <v-card-text>
          To enjoy our premium filters and premium screeners, become a PrimeInvestor
          today.
          <v-btn color="primary" class="mt-5" block @click="subscribe()">
            Subscribe now
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small outlined text @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "Subscribe",
  data() {
    return {
      enable: false
    }
  },
  methods: {
    open() {
      this.enable = true;
    },
    close() {
      this.enable = false;
    },
    subscribe() {
      window.open("https://primeinvestor.in/prime-pricing/", "_blank");
    },
  },
};
</script>

<style scoped>

.v-dialog > .v-card > .v-card__title {
      padding: 16px 21px 10px ! important;
}
</style>